import VueRouter, { RouteConfig } from 'vue-router'
import { BaseLoginService } from 'kuaidong-service'
const RCourseCenter = () => import('../views/course-center/Index.vue')
const CourseDetail = () => import('../views/course-center/CourseDetail.vue')

const OrderB2B = () => import('../views/course-center/OrderB2B.vue')
const Order = () => import('../views/course-center/Order.vue')

const EditDeliveryAddress = () => import('../views/course-center/EditDeliveryAddress.vue')
const EditInvoiceAccount = () => import('../views/course-center/EditInvoiceAccount.vue')
const OrderPaySuccess = () => import('../views/course-center/OrderPaySuccess.vue')

const OrderCourseDetail = () => import('../views/course-center/OrderCourseDetail.vue')
export const courseCenterRoute: RouteConfig = {
  path: '/course-center',
  name: 'course_center',
  component: RCourseCenter,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '课程中心',
  },
}

export const courseDetailRoute: RouteConfig = {
  path: '/course-detail',
  name: 'course_detail',
  component: CourseDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '商品详情页',
    ignoreLogin: true,
  },
}

export const orderB2BRoute: RouteConfig = {
  path: '/course-order-b2b',
  name: 'course_order_b2b',
  component: OrderB2B,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '公对公转账',
    ignoreLogin: true,
  },
}

export const orderRoute: RouteConfig = {
  path: '/course-order',
  name: 'course_order',
  component: Order,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '线上支付',
    ignoreLogin: true,
  },
}

export const orderDetailRoute: RouteConfig = {
  path: '/course-order_detail',
  name: 'course_order_detail',
  component: OrderCourseDetail,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '商品详情',
    ignoreLogin: true,
  },
}

export const editDeliveryAddressRoute: RouteConfig = {
  path: '/course-order-edit-delivery-address',
  name: 'course_order_edit_delivery_address',
  component: EditDeliveryAddress,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '收货地址',
    ignoreLogin: true,
  },
}

export const editInvoiceAccountRoute: RouteConfig = {
  path: '/course-order-edit-invoice-account',
  name: 'course_order_edit_invoice_account',
  component: EditInvoiceAccount,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '发票信息',
    ignoreLogin: true,
  },
}

export const courseOrderPaySuccessRoute: RouteConfig = {
  path: '/course-order-pay-success',
  name: 'course_order_pay_success',
  component: OrderPaySuccess,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '支付成功',
    ignoreLogin: true,
  },
}

export default [
  courseCenterRoute,
  courseDetailRoute,
  orderB2BRoute,
  orderRoute,
  editDeliveryAddressRoute,
  editInvoiceAccountRoute,
  courseOrderPaySuccessRoute,
  orderDetailRoute,
]

export function navigateToCourseOrderB2B(router: VueRouter) {
  router.push({ name: orderB2BRoute.name })
}
export function navigateToCourseOrderByWechat(router: VueRouter) {
  location.href = BaseLoginService.buildWXWebOauthUrl(orderRoute, null, router)
}

export function navigateToCourseOrderByAliPay(router: VueRouter) {
  router.push({ name: orderRoute.name })
}

export function navigateToMallCourseEditDeliveryAddress(router: VueRouter) {
  router.push({ name: editDeliveryAddressRoute.name })
}

export function navigateToMallCourseEditInvoiceAccount(router: VueRouter) {
  router.push({ name: editInvoiceAccountRoute.name })
}

export function redirectToCourseOrderPaySuccess(router: VueRouter, orderId: string) {
  router.replace({
    name: orderDetailRoute.name,
    query: {
      orderId,
    },
  })
}
